// extracted by mini-css-extract-plugin
export default {"homeLink":"HomeLink_homeLink__wH29N"};